class PasteCart {
  constructor() {
    document.addEventListener('change', this.onFlavorChange.bind(this));
    document.addEventListener('click', this.onDeleteClick.bind(this));
    document.addEventListener('click', this.onUpgradeClick.bind(this));
    document.addEventListener('click', this.onSubscribeClick.bind(this));
  }

  onFlavorChange(event) {
    const select = event.target.closest('[data-paste-flavor-select]');
    if (!select) return;

    const newVariantId = parseInt(select.value, 10);
    const itemKey = select.dataset.itemKey;
    const itemSlot = parseInt(select.dataset.itemSlot, 10);
    const sellingPlan = select.dataset.sellingPlan ? parseInt(select.dataset.sellingPlan, 10) : null;

    const group = select.closest('[data-paste-cart-group]');
    const pasteGroup = group.dataset.pasteCartGroup;
    const packSize = parseInt(group.dataset.packSize, 10);
    const packName = group.dataset.packName;
    const packType = group.dataset.packType;
    const packDiscountPerItem = parseInt(group.dataset.packDiscountPerItem, 10) || 0;

    group.setAttribute('data-paste-loading', '');

    const newItem = {
      id: newVariantId,
      quantity: 1,
      properties: {
        'Pack size': packName,
        _pasteGroup: pasteGroup,
        _packSize: packSize,
        _packName: packName,
        _packType: packType,
        _packDiscountPerItem: packDiscountPerItem,
        _slot: itemSlot,
        _hasRepeat: sellingPlan ? 'true' : 'false',
      },
    };
    if (sellingPlan) newItem.selling_plan = sellingPlan;

    this.removeItem(itemKey)
      .then(() => this.addItem(newItem))
      .then(() => this.refreshCart())
      .catch(error => console.error('[paste-cart] flavor change error:', error))
      .finally(() => group.removeAttribute('data-paste-loading'));
  }

  onDeleteClick(event) {
    const button = event.target.closest('[data-paste-group-remove]');
    if (!button) return;

    const group = button.closest('[data-paste-cart-group]');
    const keys = JSON.parse(group.dataset.pasteGroupItemKeys);

    group.setAttribute('data-paste-loading', '');

    const updates = {};
    keys.forEach(key => {
      updates[key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then(response => response.json())
      .then(() => this.refreshCart())
      .catch(error => console.error('[paste-cart] delete error:', error))
      .finally(() => group.removeAttribute('data-paste-loading'));
  }

  onUpgradeClick(event) {
    const button = event.target.closest('[data-paste-upgrade]');
    if (!button) return;

    const group = document.querySelector(`[data-paste-cart-group="${button.dataset.pasteCartGroupRef}"]`);
    const pasteGroup = group.dataset.pasteCartGroup;
    const packType = group.dataset.packType;
    const newPackSize = parseInt(button.dataset.targetPackSize, 10);
    const newPackName = button.dataset.targetPackName;
    const newPackDiscountPerItem = parseInt(button.dataset.targetPackDiscountPerItem, 10) || 0;

    const selects = [...group.querySelectorAll('[data-paste-flavor-select]')];
    const existingItems = selects.map(select => ({
      variantId: parseInt(select.dataset.itemVariantId, 10),
      slot: parseInt(select.dataset.itemSlot, 10),
      key: select.dataset.itemKey,
      sellingPlan: select.dataset.sellingPlan ? parseInt(select.dataset.sellingPlan, 10) : null,
    }));

    const oldKeys = existingItems.map(item => item.key);
    const currentPackSize = existingItems.length;
    const allNewItems = [];

    existingItems.forEach(item => {
      const newItem = {
        id: item.variantId,
        quantity: 1,
        properties: {
          'Pack size': newPackName,
          _pasteGroup: pasteGroup,
          _packSize: newPackSize,
          _packName: newPackName,
          _packType: packType,
          _packDiscountPerItem: newPackDiscountPerItem,
          _slot: item.slot,
          _hasRepeat: item.sellingPlan ? 'true' : 'false',
        },
      };
      if (item.sellingPlan) newItem.selling_plan = item.sellingPlan;
      allNewItems.push(newItem);
    });

    for (let s = currentPackSize + 1; s <= newPackSize; s++) {
      const source = existingItems[(s - 1) % currentPackSize];
      const newItem = {
        id: source.variantId,
        quantity: 1,
        properties: {
          'Pack size': newPackName,
          _pasteGroup: pasteGroup,
          _packSize: newPackSize,
          _packName: newPackName,
          _packType: packType,
          _packDiscountPerItem: newPackDiscountPerItem,
          _slot: s,
          _hasRepeat: source.sellingPlan ? 'true' : 'false',
        },
      };
      if (source.sellingPlan) newItem.selling_plan = source.sellingPlan;
      allNewItems.push(newItem);
    }

    group.setAttribute('data-paste-loading', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: allNewItems }),
    })
      .then(response => response.json())
      .then(() => {
        const updates = {};
        oldKeys.forEach(key => {
          updates[key] = 0;
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        }).then(response => response.json());
      })
      .then(() => this.refreshCart())
      .catch(error => console.error('[paste-cart] upgrade error:', error))
      .finally(() => group.removeAttribute('data-paste-loading'));
  }

  onSubscribeClick(event) {
    const button = event.target.closest('[data-paste-subscribe]');
    if (!button) return;

    const group = document.querySelector(`[data-paste-cart-group="${button.dataset.pasteCartGroupRef}"]`);
    const pasteGroup = group.dataset.pasteCartGroup;
    const packType = group.dataset.packType;
    const packSize = parseInt(group.dataset.packSize, 10);
    const packName = group.dataset.packName;
    const subscriptionPlanId = parseInt(group.dataset.subscriptionPlan, 10);
    const packDiscountPerItem = parseInt(group.dataset.packDiscountPerItem, 10) || 0;

    const selects = [...group.querySelectorAll('[data-paste-flavor-select]')];
    const existingItems = selects.map(select => ({
      subscriptionVariantId: parseInt(select.selectedOptions[0]?.dataset.subscriptionVariantId, 10) || parseInt(select.value, 10),
      slot: parseInt(select.dataset.itemSlot, 10),
      key: select.dataset.itemKey,
    }));

    const newItems = existingItems.map(item => ({
      id: item.subscriptionVariantId,
      quantity: 1,
      selling_plan: subscriptionPlanId,
      properties: {
        'Pack size': packName,
        _pasteGroup: pasteGroup,
        _packSize: packSize,
        _packName: packName,
        _packType: packType,
        _packDiscountPerItem: packDiscountPerItem,
        _slot: item.slot,
        _hasRepeat: 'true',
      },
    }));

    const oldKeys = existingItems.map(item => item.key);
    group.setAttribute('data-paste-loading', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: newItems }),
    })
      .then(response => response.json())
      .then(() => {
        const updates = {};
        oldKeys.forEach(key => {
          updates[key] = 0;
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        }).then(response => response.json());
      })
      .then(() => this.refreshCart())
      .catch(error => console.error('[paste-cart] subscribe error:', error))
      .finally(() => group.removeAttribute('data-paste-loading'));
  }

  removeItem(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(response => response.json());
  }

  addItem(item) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item]}),
    }).then(response => response.json());
  }

  refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.renderCartDrawer();
      return;
    }
    window.location.reload();
  }
}

new PasteCart();
